import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";
import Spinner from "../Spinner";
import OwlCarousel from "react-owl-carousel";
import { limitParagraphByCharLimit } from "../../Helper/Helper";

function HighlightPopCardFacilities() {
  const [facilitiesData, setFacilitiesData] = useState([]);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    const response = await SendPostRequest("facilities");
    setFacilitiesData(response?.data);
  };

  const options = {
    loop: true,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    margin: 30,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
    },
  };

  return (
    <>
      {facilitiesData?.length > 0 ? (
        <section id="feature-section" className="feature-section pb-4 pt-5">
          <div className="container">
            <div className="row mb-4">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-40">
                    <h2 className="title mb-0 text-uppercase">
                      Our <span className="theme-color">Facilities</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row" data-animation="fadeInDown">
              {facilitiesData?.length === 0 ? (
                <div
                  style={{ marginBottom: "100px" }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Spinner />
                </div>
              ) : (
                <OwlCarousel className="service-main-wrapper" {...options}>
                  {facilitiesData?.map((data, index) => (
                    <div key={index} className="item">
                      <div className="service-box-wrap service-box-style-2 mb-4">
                        <div className="service-box-inner">
                          <div className="service-thumb">
                            <Link
                              to={`/facility/${data?.facility_slug
                                ?.replaceAll(" ", "-")
                                ?.replaceAll("/", "-")}`}
                            >
                              <img
                                className="img-fluid squared w-100"
                                src={
                                  data?.facility_image ||
                                  "/assets/images/default.jpg"
                                }
                                style={{ height: "auto" }}
                                width="!00%"
                                alt={data?.facility_title}
                              />
                            </Link>
                          </div>
                          <div className="service-main-content">
                            <h3 className="mb-0 service-title">
                              <Link
                                to={`/facility/${data?.facility_slug
                                  ?.replaceAll(" ", "-")
                                  ?.replaceAll("/", "-")}`}
                              >
                                {data?.facility_title}
                              </Link>
                            </h3>
                            <div className="service-link">
                              <Link
                                to={`/facility/${data?.facility_slug
                                  ?.replaceAll(" ", "-")
                                  ?.replaceAll("/", "-")}`}
                                className="link"
                              >
                                <i className="ti-arrow-top-right"></i>
                              </Link>
                            </div>
                          </div>
                          <div className="service-overlay-content">
                            <div className="service-meta">
                              <h3 className="mb-2 service-title">
                                <Link
                                  to={`/facility/${data?.facility_slug
                                    ?.replaceAll(" ", "-")
                                    ?.replaceAll("/", "-")}`}
                                >
                                  {data?.facility_title}
                                </Link>
                              </h3>
                              <div className="service-link">
                                <Link
                                  to={`/facility/${data?.facility_slug
                                    ?.replaceAll(" ", "-")
                                    ?.replaceAll("/", "-")}`}
                                  className="link"
                                >
                                  <i className="ti-arrow-top-right"></i>
                                </Link>
                              </div>
                            </div>
                            {/* <div className="service-desc">
                              <p
                                className="mb-0"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    limitParagraphByCharLimit(data?.facility_short_description, 140) +
                                    (data?.facility_short_description?.length > 140 ? "..." : ""),
                                }}
                              />
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              )}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}

export default HighlightPopCardFacilities;
